(function(angular, schoolwork12) {
'use strict';
angular.module(schoolwork12.app.student.name)
    .factory(schoolwork12.app.student.services.manageSchoolDataSvc, ['$http', '$q', function ($http, $q) {

            var getDataFieldsbySchools = function (keycode, userSchools) {

                var userSchoolIds = _.pluck(userSchools, 'schoolId');
                console.info('In getDataFieldsbySchools service');
                var dataFields = null;
                var deferred = $q.defer();
                var request = $http({
                     method: 'POST',
                     url: schoolwork12.app.student.endpoints.schoolsSearch +'dataFields',
                     data : {                                    
                                schoolIds: userSchoolIds.toString(), 
                            },
                     headers: {
                         'Content-Type': 'application/json',
                         'X-API-TOKEN': keycode
                    }
                });
                 request.then(function (response) {
                     dataFields = response.data;
                     deferred.resolve(dataFields);
                     console.info('Got the data fields by schools');
                 }, function (error) {  
                     deferred.reject(error);
                 });
                 return deferred.promise;
            }; 

            var getActiveSchoolPartPrograms = function (keycode, schoolId) {
                console.info('In get ActiveSchoolPartPrograms service call');
                console.info('Making a call to service');
                var activeSchoolPartProgramList = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.manageSchoolData.endpoints.schoolDataEndPoint + schoolId + '/activeSchoolPartPrograms',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got all part programs list');
                    activeSchoolPartProgramList = response.data;
                    deferred.resolve(activeSchoolPartProgramList);
                }, function (error) {
                    console.info("Error occured while getting list of active school Part Programs ");
                    deferred.reject(error);
                });
                return deferred.promise;
            };
        
            return {
                getDataFieldsbySchools: getDataFieldsbySchools,
                getActiveSchoolPartPrograms: getActiveSchoolPartPrograms
            };
        } 

    ]);
}(angular, schoolwork12));